import { appendLogBufferEntry } from './logBufferStorage';
import { buildConsoleLogLine } from './logReportService';
import { enqueueDevLogLine } from './devFileSink';

const LOGGER_CONSOLE_PREFIX = /^\[(DEBUG|INFO|WARN|ERROR)\]\[/;

let consolePatched = false;

const nativeConsole = {
  log: console.log.bind(console),
  info: console.info.bind(console),
  debug: console.debug.bind(console),
  warn: console.warn.bind(console),
  error: console.error.bind(console),
};

function isStructuredLoggerOutput(args) {
  const first = args[0];
  return typeof first === 'string' && LOGGER_CONSOLE_PREFIX.test(first);
}

function persistConsoleLine(level, line) {
  appendLogBufferEntry({
    level,
    module: 'Console',
    message: line,
    line,
    timestamp: Date.now(),
  });
  if (import.meta.env.DEV) {
    enqueueDevLogLine(line);
  }
}

function wrapConsoleMethod(level, original) {
  return (...args) => {
    original(...args);
    if (!isStructuredLoggerOutput(args)) {
      const line = buildConsoleLogLine(level, args);
      persistConsoleLine(level, line);
    }
  };
}

export function writeToNativeConsole(level, ...args) {
  const writer = nativeConsole[level] || nativeConsole.log;
  writer(...args);
}

export function initConsoleCapture() {
  if (consolePatched) {
    return;
  }
  consolePatched = true;
  console.log = wrapConsoleMethod('info', nativeConsole.log);
  console.info = wrapConsoleMethod('info', nativeConsole.info);
  console.debug = wrapConsoleMethod('debug', nativeConsole.debug);
  console.warn = wrapConsoleMethod('warn', nativeConsole.warn);
  console.error = wrapConsoleMethod('error', nativeConsole.error);
}
